export function genericBaseUrl(prefix: string, ...path: any[]) {
  return [prefix, ...path].join('/');
}
